module.exports = __webpack_public_path__ + "media/images/brand/app_logo_250-300c543a18f82d10ad17648a66f4f1b8.png";